function getFormData() {
    return $(".existing-member-form").serializeArray();
}

function getFormObject() {
    return $(".existing-member-form").serialize();
}

function onFindExistingFormSubmitted(callback) {
    $(".existing-member-form").on("submit", callback);
    $(".existing-member-form .btn-primary").on("touchend", callback);
}

function showErrorMessage(errorMessage) {
    $('.errors-serverside__error-message')
        .html(errorMessage)
        .removeClass('errors-serverside__error-message--hidden');
    $('.find-existing__errors-serverside').removeClass('errors-serverside--hidden');
    $('html, body').scrollTop(0);
}

function hideServerSideErrors() {
    $('.find-existing__errors-serverside').addClass('errors-serverside--hidden');
}

function isFormDataValid() {
    return $('.existing-member-form').parsley('validate').isValid();
}

function addSpinner() {
    $(".link-account-button").addClass("btn-loading");
}

function removeSpinner() {
    $(".link-account-button").removeClass("btn-loading");
}

function disableLinkAccountButton() {
    $(".link-account-button").prop("disabled", true);
}

function enableLinkAccountButton() {
    $(".link-account-button").prop("disabled", false);
}

function disableCardNumberField() {
    $('.membership-number').attr('disabled', 'disabled');
}

function enableCardNumberField() {
    $('.membership-number').removeAttr('disabled');

}

module.exports = {
    allowedRedirectDomain: () => $(".existing-member-form").attr("data-allowed-redirects-domain"),
    webUrl: () => $(".existing-member-form").attr("web-url"),
    onFindExistingFormSubmitted: onFindExistingFormSubmitted,
    getFormData: getFormData,
    getFormObject: getFormObject,
    showErrorMessage: showErrorMessage,
    hideServerSideErrors: hideServerSideErrors,
    isFormDataValid: isFormDataValid,
    addSpinner: addSpinner,
    removeSpinner: removeSpinner,
    disableCardNumberField: disableCardNumberField,
    enableCardNumberField: enableCardNumberField,
    disableLinkAccountButton: disableLinkAccountButton,
    enableLinkAccountButton: enableLinkAccountButton
};
